<template>
    <div component="loginForm">
        <span class="close" @click="close">
            <span class="icon">close</span>
        </span>
        <div class="title"><span class="icon">power_settings_new</span>&nbsp;LOGIN</div>
        <div class="wrapper">
            <transition :name="grant_type ? 'right' : 'left'">
                <div class="buttons" v-if="!grant_type">
                    <btn
                        :icon="'tablet_mac'"
                        :text="'SMS'"
                        :size="'big'"
                        :radius="'big'"
                        @click="grant_type = 'sms_code'"
                    />
                    <btn
                        :icon="'email'"
                        :text="'EMAIL'"
                        :size="'big'"
                        :radius="'big'"
                        @click="grant_type = 'email_code'"
                    />
                    <btn
                        v-show="$env.isDevelopment"
                        :icon="'account_circle'"
                        :text="'Implicit login'"
                        :size="'big'"
                        :radius="'big'"
                        @click="openImplicitWindow"
                    />
                    <form class="password-login" v-show="$env.isDevelopment" @submit.prevent="login">
                        <input
                            type="text"
                            name="username"
                            v-model="pwdLogin.username"
                            v-validate="'required|email'"
                            placeholder="Username"
                        />
                        <input
                            type="password"
                            name="password"
                            v-model="pwdLogin.password"
                            v-validate="'required'"
                            placeholder="Password"
                        />
                        <span class="error-message" v-if="pwdLogin.error">{{ pwdLogin.error }}</span>
                        <btn
                            :icon="'account_circle'"
                            :text="'Login'"
                            :size="'big'"
                            :radius="'big'"
                            :state="pwdLogin.loading ? 'load' : ''"
                        />
                    </form>
                </div>
            </transition>
            <transition :name="grant_type ? 'right' : 'left'">
                <login-code-form
                    v-if="grant_type"
                    :grant_type="grant_type"
                    @setChannel="grant_type = $event"
                    @success="success"
                />
            </transition>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import LoginCodeForm from './LoginCodeForm.vue';

export default {
    name: 'LoginForm',

    components: {
        LoginCodeForm,
    },

    data() {
        return {
            grant_type: undefined,

            pwdLogin: {
                loading: false,
                username: '',
                password: '',
                error: '',
            },
        };
    },

    methods: {
        close() {
            this.grant_type = undefined;
            this.$store.commit('closeAllPopups');
        },
        success() {
            this.grant_type = undefined;
            this.$emit('success');
        },
        async openImplicitWindow() {
            await this.$store.dispatch('openImplicitWindow');
            this.success();
        },
        async login() {
            if (!this.pwdLogin.username || !this.pwdLogin.password) return;
            try {
                this.pwdLogin.error = '';
                this.pwdLogin.loading = true;
                this.$bugsnag.leaveBreadcrumb('Logging in...');
                await this.$store.dispatch('login', {
                    grant_type: 'password',
                    username: this.pwdLogin.username,
                    password: this.pwdLogin.password,
                });
                this.pwdLogin = {
                    ...this.pwdLogin,
                    username: '',
                    password: '',
                    error: '',
                };
                this.success();
            } catch (e) {
                this.pwdLogin.error =
                    e.response.data.message || e.response.data.error_description || e.response.data.error;

                if (![401].includes(e.response.status)) {
                    this.$bugsnag.notify(e);
                }
            } finally {
                this.pwdLogin.loading = false;
            }
        },
    },
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='loginForm'] {
    width: 100%;
    height: 100%;
    .flex-center;
    flex-direction: column;
    position: relative;
    overflow: hidden;

    .close {
        top: -10px;
        z-index: 1;
        right: -10px;
        padding: 10px;
        position: absolute;

        &:focus {
            outline: none;
        }
    }

    .title {
        margin: 30px;
        width: 100%;
        .flex-center;
        font-size: 17px;
        font-weight: 900;
        letter-spacing: 0.02em;
    }

    .wrapper {
        width: 100%;
        min-height: 200px;
    }

    .buttons {
        display: flex;
        flex-direction: column;
        width: 100%;

        button {
            margin: 5px 0;
            padding: 0 20px;
        }
    }

    form.password-login {
        display: flex;
        flex-direction: column;

        button {
            width: 100%;
            margin-top: 10px;
        }

        .error-message {
            top: 5px;
            color: @accent;
            font-size: 11px;
            display: block;
            position: relative;
        }
    }
}
</style>
